import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/document-services/document-services/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const TextBlock = makeShortcode("TextBlock");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <TextBlock slots="heading" width="100%" theme="light" alignment="yes" className="py-0 text-align-left border-right div-p-0 left-content link linking pricing-h2" mdxType="TextBlock" />
    <h3 {...{
      "id": "free-tier"
    }}>{`Free Tier`}</h3>
    <TextBlock slots="text" width="100%" theme="light" alignment="yes" paddingTop="5" paddingBottom='5' className="py-0 list-points border-right div-p-0 left-content" mdxType="TextBlock" />
    <ul>
      <li parentName="ul">
        <p parentName="li">{`500 free Document Transactions per month`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Access to all 15+ PDF Services including PDF Extract, PDF Accessibility APIs, and Document Generation`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Easy to sign up and create credentials in minutes`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`No credit card or commitment required`}</p>
      </li>
    </ul>
    <TextBlock slots="buttons" width="100%" theme="light" alignment="yes" paddingTop="5" paddingBottom='5' primaryOutline className="pb-1 border-right left-Contact div-p-0 left-content" mdxType="TextBlock" />
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://documentservices.adobe.com/dc-integration-creation-app-cdn/main.html?api=pdf-services-api"
        }}>{`Start for free`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      